module.exports = __webpack_public_path__ + "assets/unavailable.99788515.svg";